import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = ["loading", "error"]
  static values = { nextUrl: String }

  connect() {
    this.observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && this.hasNextUrlValue) {
        this.observer.disconnect()
        this.loadMore()
      }
    }, { root: this.scrollableAncestor() })
    this.observer.observe(this.element)
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }

  scrollableAncestor() {
    let node = this.element.parentElement
    while (node && node !== document.body) {
      const overflowY = getComputedStyle(node).overflowY
      if ((overflowY === "auto" || overflowY === "scroll") && node.scrollHeight > node.clientHeight) {
        return node
      }
      node = node.parentElement
    }
    return null
  }

  loadMore() {
    fetch(this.nextUrlValue, {
      headers: { Accept: "text/vnd.turbo-stream.html" }
    })
      .then(response => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        return response.text()
      })
      .then(html => Turbo.renderStreamMessage(html))
      .catch((error) => {
        console.error("Failed to load more:", error)
        this.showError()
      })
  }

  showError() {
    if (this.hasLoadingTarget) this.loadingTarget.classList.add("hidden")
    if (this.hasErrorTarget) this.errorTarget.classList.remove("hidden")
  }

  retry(event) {
    event.preventDefault()
    if (this.hasLoadingTarget) this.loadingTarget.classList.remove("hidden")
    if (this.hasErrorTarget) this.errorTarget.classList.add("hidden")
    this.loadMore()
  }
}
